/**
 * IMPORTS
 */

import { BookUser, CircleDollarSign, Edit, Trash, Users } from "lucide-react";

// typings
import type { ICliente } from "@/store-zustand/manage-client/index.d";

import { FEATURES, hasFeature } from "@/utils/auth/features";

import { IActionsTableGerenciarClientes } from "../interface";
import { abrirEdicaoCliente } from "./abrir-edicao-cliente";

function getGerenciarClientesTableActions({
  router,
  features,
  setUserIdCliente,
  setClienteEditar,
  isModalAddCredit,
  setIsModalAddCredit,
  isModalExclude,
  setIsModalExclude,
}: IActionsTableGerenciarClientes) {
  return [
    {
      icon: Users,
      label: "Usuários",
      textColor: "text-red-600",
      disabled: !hasFeature(features, FEATURES.VISUALIZAR_USUARIO_CLIENTE),
      onClick: (item: ICliente) =>
        router("/manage-client-users", {
          state: {
            cliente: {
              id: item?.id,
              nome: item?.nome,
              email: item.email,
            },
          },
        }),
    },
    {
      icon: CircleDollarSign,
      label: "Créditos",
      textColor: "text-red-600",
      disabled: !hasFeature(features, FEATURES.GERENCIAR_CREDITOS_CLIENTE),
      onClick: (item: ICliente) => {
        setUserIdCliente(item?.id);
        setIsModalAddCredit(!isModalAddCredit);
      },
    },
    {
      icon: BookUser,
      label: "Modelos",
      textColor: "text-red-600",
      disabled: !hasFeature(features, FEATURES.VISUALIZAR_MODELOS_TECNICOS),
      onClick: (item: ICliente) => {
        router("/manage-technical-sheets", {
          state: {
            userCliente: item.id,
            nome: item.nome,
          },
        });
      },
    },
    {
      icon: Edit,
      label: "Editar",
      textColor: "text-red-600",
      disabled: !hasFeature(features, FEATURES.EDITAR_CLIENTE),
      onClick: (item: ICliente) => abrirEdicaoCliente({ router, setClienteEditar, cliente: item }),
    },
    {
      icon: Trash,
      label: "Inativar Usuário",
      textColor: "text-red-600",
      disabled: !hasFeature(features, FEATURES.INATIVAR_CLIENTE),
      onClick: (item: ICliente) => {
        setClienteEditar(item);
        setIsModalExclude(!isModalExclude);
      },
    },
  ];
}

/**
 * EXPORTS
 */
export { getGerenciarClientesTableActions };
